import React from 'react'

import { OfflinePage } from 'libs/network/OfflinePage'

export const CheatcodesScreenOffline = () => <OfflinePage />
